import SearchBar from 'components/SearchBar/SearchBar';
import BaseSelect from 'components/Selects/BaseSelect/BaseSelect';
import CustomSlider from 'components/Sliders/CustomSlider';
import Toggle from 'components/UI/Toggle';
import { nwsAlertTypes } from 'features/Weather/features/WeatherAlerts/config/nwsAlertTypes.config';
import { Button } from 'react-bootstrap';
import { FaSort } from 'react-icons/fa6';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  selectFilteredAlertList,
  selectListConfig,
  selectMaxDist,
  selectSearchTerm,
  selectSeveritySortDirection,
  selectShowLocalOnly,
} from '../../state/selectors/alertListSelectors';
import {
  setAlertTypes,
  setMaxDist,
  setPageIndex,
  setSearchTerm,
  setSeveritySortDirection,
  setShowLocalOnly,
} from '../../state/slices/alertListSlice';

const EMPTY_ALERT_TYPES = [];

const AlertListHeader = ({ title, perms }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const filteredAlertList = useSelector(selectFilteredAlertList);
  const severitySortDirection = useSelector(selectSeveritySortDirection);
  const showLocalOnly = useSelector(selectShowLocalOnly);
  const maxDist = useSelector(selectMaxDist);
  const searchTerm = useSelector(selectSearchTerm);

  const severitySort = () => {
    const newValue = !severitySortDirection;
    dispatch(setSeveritySortDirection(newValue));
  };

  const selectedAlertTypes =
    useSelector((state) => selectListConfig(state).alertTypes) ?? EMPTY_ALERT_TYPES;
  const alertTypeOptions = nwsAlertTypes.map((label) => ({ label, value: label }));
  const selectedAlertTypeOptions = alertTypeOptions.filter(({ value }) =>
    selectedAlertTypes.includes(value),
  );

  const handleSetAlertTypes = (values) => {
    dispatch(setAlertTypes(values));
    dispatch(setPageIndex(1));
  };

  return (
    <div>
      <div className="d-flex flex-column align-items-center flex-xl-row justify-content-md-between mb-3">
        <div className="d-flex flex-column align-items-center flex-fill flex-xl-row gap-3 gap-xl-5">
          <div className="fs-4 fw-bold">{title}</div>
          <SearchBar
            className="w-auto d-flex"
            value={searchTerm}
            onChange={(value) => {
              dispatch(setSearchTerm(value));
              dispatch(setPageIndex(1));
            }}
          />
          <div style={{ width: 'clamp(220px, 35vw, 450px)', flexShrink: 0 }}>
            <BaseSelect
              inputId="weather-alert-types-filter"
              wrapperClassName="w-100"
              isMulti
              isSearchable
              isClearable
              maxMenuHeight={320}
              classNames={{
                control: () => 'bg-primary',
              }}
              selectProps={{
                'aria-label': 'Alert types',
                options: alertTypeOptions,
                value: selectedAlertTypeOptions,
                placeholder: 'Alert Types Filter',
                onChange: (options) =>
                  handleSetAlertTypes((options ?? []).map((option) => option.value)),
              }}
            />
          </div>
          <div className="d-flex gap-2 align-content-center align-items-center">
            <Toggle
              value={showLocalOnly}
              callback={(value) => {
                dispatch(setShowLocalOnly(value));
                dispatch(setPageIndex(1));
              }}
              label="Show Local Only"
            />
            {showLocalOnly && (
              <div style={{ marginLeft: 20 }}>
                Max Distance (mi):{' '}
                <input
                  type="number"
                  min={0}
                  max={1000}
                  value={maxDist}
                  onChange={(e) => {
                    dispatch(setMaxDist(e.target.value));
                  }}
                />
                <CustomSlider
                  value={maxDist}
                  onChange={(value) => {
                    dispatch(setPageIndex(1));
                    dispatch(setMaxDist(value));
                  }}
                  min={0}
                  max={1000}
                  step={5}
                  style={{ width: 150 }}
                />
              </div>
            )}
          </div>
        </div>
        {perms.testPermission([8, 9, 10, 11, 12, 13], ['Create-EditAlerts']) && (
          <Button
            className="px-5 rounded-3 mt-3"
            onClick={() => navigate('/publicuser/createAlert')}
            variant="primary"
          >
            Create Alert
          </Button>
        )}
      </div>
      {filteredAlertList?.length > 0 && (
        <div className="d-flex align-items-center cursor-pointer" onClick={() => severitySort()}>
          Severity <FaSort />
        </div>
      )}
    </div>
  );
};

export default AlertListHeader;
